import { useState } from "react";
import { useAuthStore } from "../stores/auth";
import { Button } from "../components/ui/button";
import { Input, Field } from "../components/ui/input";
import { BrandMark } from "../components/ui/brand-mark";
import { blueprint } from "../blueprint";

export function Login() {
  const login = useAuthStore((s) => s.login);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [submitting, setSubmitting] = useState(false);

  return (
    <div className="login">
      <form
        className="login__form"
        onSubmit={async (e) => {
          e.preventDefault();
          setError(null);
          setSubmitting(true);
          try {
            await login(email, password);
          } catch {
            setError("Identifiants invalides");
          } finally {
            setSubmitting(false);
          }
        }}
      >
        <div className="login__head">
          <BrandMark size={40} />
          <div>
            <h1 className="login__title">{blueprint.name}</h1>
            {blueprint.tagline ? <p className="login__subtitle">{blueprint.tagline}</p> : null}
          </div>
        </div>
        <Field label="Courriel">
          <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required autoComplete="email" />
        </Field>
        <Field label="Mot de passe">
          <Input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="current-password"
          />
        </Field>
        {error ? (
          <p className="login__error" role="alert">
            {error}
          </p>
        ) : null}
        <Button variant="primary" type="submit" disabled={submitting}>
          {submitting ? "Connexion…" : "Se connecter"}
        </Button>
      </form>
    </div>
  );
}
